import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  toolbar: {
    display: 'flex',
    height: '72px',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
    borderBottom: `1px solid ${theme.palette.custom.border}`,
    paddingLeft: 'unset',
    paddingRight: theme.spacing(1),
  },
  titleWrapper: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '24px',
  },
  link: {
    height: '72px',
    marginRight: theme.spacing(3.25),
  },
  logo: {
    width: '72px',
  },
  accountWrapper: {},
  iconButton: {
    color: 'inherit',
    padding: theme.spacing(2.25),
  },
  icon: {
    fontSize: '20px',
  },
}));
